<template>
  <aside
    class="my-3 overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="[isRTL ? 'me-3 rotate-caret' : 'ms-3', { 'sidenav-mobile-open': isMobileOpen }]"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
        @click="closeMobileMenu"
      ></i>
      <router-link class="m-0 navbar-brand" :to="{ name: 'Welcome' }">
        <img :src="logo" class="navbar-brand-img h-100" alt="main_logo" />
        <!-- <span class="ms-1 font-weight-bold">Valora</span> -->
      </router-link>
    </div>
    <hr class="mt-0 sidenav-divider" />
    <sidenav-list :cardBg="customClass" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";
import logo from "@/assets/img/logo-valora.png";
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
      logo,
    };
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["isRTL"]),
    isMobileOpen() {
      return this.$store.state.isPinned;
    },
  },
  methods: {
    closeMobileMenu() {
      this.$store.commit("closeSidenavMobile");
    },
  },
};
</script>

<style scoped>
#sidenav-main {
  box-shadow: 0 0 0 1px rgba(23, 193, 232, 0.06), 0 8px 30px rgba(23, 193, 232, 0.1);
}

.sidenav-divider {
  height: 2px;
  border: none;
  border-radius: 2px;
  background: linear-gradient(90deg, rgba(23, 193, 232, 0.35) 0%, rgba(32, 201, 151, 0.35) 100%);
  opacity: 1;
}

@media (max-width: 1199.98px) {
  #sidenav-main {
    transform: translateX(-110%) !important;
    transition: transform 0.3s ease-in-out !important;
    box-shadow: 0 0 40px rgba(23, 193, 232, 0.25);
  }

  #sidenav-main.sidenav-mobile-open {
    transform: translateX(0) !important;
  }
}
</style>
